import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { Box } from '@mui/material';
import BasicEmployee from '../container/layouts/BasicEmployee';
import EmployeeSalaryList from './EmployeeView/EmployeeSalaryList';
import EmployeeTimeSheet from './EmployeeView/EmployeeTimeSheet';
import SwipeableTabs from '../container/MUI/SwipeableTabs';
import Notif from './common/Notif';
import EmployeeDemandList from './EmployeeView/EmployeeDemandList';
import EmployeeEquipementList from './EmployeeView/EmployeeEquipementList';

class HomePageEmployee extends Component {
    state = {  
        notif: {
            openNotif: false,
            variant:"",
            message: "",
        },
    }
    notif = (variant, message) => {
        console.log('==================NOTIF==================');
        console.log(variant, message);
        console.log('====================================');
        this.setState({
            notif:{
                openNotif: true,
                variant,
                message
            }
        })
    }
    handleCloseNotif = () => {
        this.setState({ 
            notif: {
                openNotif: false,
                variant:"",
                message: "",
            }
        });
    };
    render() {
        console.log("[PROPS]", this.props)
        const { openNotif, variant, message} = this.state.notif;
        let labels = ["Planning", "Salaires", "Materiels"]
        if (!isEmpty(this.props.CURRENT_SESSION)) {
            labels.push("Demandes")
        }
        console.log('====================================');
        console.log({labels});
        console.log('====================================');
        return (
            <BasicEmployee>
                {openNotif && variant && message &&
                    <Notif open={true} {...this.state.notif} onClose={this.handleCloseNotif} />
                }
                <SwipeableTabs
                    labels={labels}    
                >
                    <EmployeeTimeSheet {...this.props} notif={this.notif}/>
                    <EmployeeSalaryList {...this.props} /> 
                    <EmployeeEquipementList {...this.props} notif={this.notif} /> 
                    {!isEmpty(this.props.CURRENT_SESSION) &&
                        <EmployeeDemandList {...this.props}  notif={this.notif}/>                
                    }               

                </SwipeableTabs>
                
            </BasicEmployee>
        );
    }
}

export default HomePageEmployee;